import { FirestoreDocumentReference } from "../../../../../api/firebase/references";
import { BOOptionModel } from "../../../../../data-model/boOptionModel";
import { ModalId } from "../../../../../enums/modalId";
import { useOptionsConfig } from "./useOptionsConfig";

export const useBoOptions = (selectedOrgId: string) => {
  return useOptionsConfig<BOOptionModel>({
    selectedOrgId,
    fetchDocumentRef: FirestoreDocumentReference.boOptions,
    documentKey: "bo_options",
    modalId: ModalId.BO_OPTIONS_MODAL,
    deleteModalId: ModalId.BO_OPTIONS_DELETE_MODAL,
    getUniqueKey: (item) => item.value,
    sortFields: ["priority"],
  });
};
